import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["buttonLabel", "children", "use", "size", "disableColorRemap"];
import I18n from 'I18n';
import { Button } from 'foundations-components/transitional/components/Button';
import { Flex } from 'foundations-components/components/Flex';
import { RightIcon } from 'foundations-assets/icons/components/RightIcon';
import { TourButtonLabel } from '../constants/styles';
import { usePrimaryButtonStyle } from '../constants/buttonUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function renderDefaultContent({
  label,
  iconColor
}) {
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    gap: "100",
    children: [/*#__PURE__*/_jsx(TourButtonLabel, {
      children: label !== null && label !== void 0 ? label : I18n.text('shepherd-react.next')
    }), /*#__PURE__*/_jsx(RightIcon, {
      size: "100",
      color: iconColor
    })]
  });
}

/**
 * Bare-bones tour step button: the shared primary "on-fill" styling and the
 * default label + chevron layout, with no tour behavior of its own. It is the
 * presentational base that `UITourNextButton` builds on, and the fallback for
 * step buttons that only navigate (e.g. a tooltip button with an `href`) and so
 * must not advance the tour.
 */
const UITourButton = _ref => {
  let {
      buttonLabel,
      children,
      use = 'primary-on-fill',
      size = 'small',
      disableColorRemap
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    use: resolvedUse,
    iconColor
  } = usePrimaryButtonStyle({
    use,
    disableColorRemap
  });
  return /*#__PURE__*/_jsx(Button, Object.assign({
    use: resolvedUse,
    size: size
  }, buttonProps, {
    children: children !== null && children !== void 0 ? children : renderDefaultContent({
      label: buttonLabel,
      iconColor
    })
  }));
};
export default UITourButton;